module.exports = __webpack_public_path__ + "img/icon_category_02.f7b8f159.svg";